import { trpc, vanillaClient } from "@/lib/api/trpc";
import { toast } from "react-hot-toast";
import type { ExportCashOutsInput } from "@restaurant-staff-portal/shared";

export function useCashOut() {
  // @ts-ignore - tRPC type issues
  const utils = trpc.useContext();

  // @ts-ignore - tRPC type issues
  const getCashOuts = trpc.cashOut.getAll.useQuery;

  // @ts-ignore - tRPC type issues
  const getCashOut = trpc.cashOut.getById.useQuery;

  // @ts-ignore - tRPC type issues
  const createCashOut = trpc.cashOut.create.useMutation({
    onSuccess: () => {
      // Invalidate all cashOut queries including listAll and listMine
      // @ts-ignore - tRPC type issues
      utils.cashOut.listAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.listMine.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getMy.invalidate();
      toast.success("Cash out created successfully");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to create cash out");
    },
  });

  // @ts-ignore - tRPC type issues
  const updateCashOut = trpc.cashOut.update.useMutation({
    onSuccess: () => {
      // Invalidate all cashOut queries including listAll and listMine
      // @ts-ignore - tRPC type issues
      utils.cashOut.listAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.listMine.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getMy.invalidate();
      toast.success("Cash out updated successfully");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to update cash out");
    },
  });

  // @ts-ignore - tRPC type issues
  const deleteCashOut = trpc.cashOut.delete.useMutation({
    onSuccess: () => {
      // Invalidate all cashOut queries including listAll and listMine
      // @ts-ignore - tRPC type issues
      utils.cashOut.listAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.listMine.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getMy.invalidate();
      toast.success("Cash out deleted successfully");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to delete cash out");
    },
  });

  // @ts-ignore - tRPC type issues
  const approveCashOut = trpc.cashOut.approve.useMutation({
    onSuccess: () => {
      // Invalidate all cashOut queries including listAll and listMine
      // @ts-ignore - tRPC type issues
      utils.cashOut.listAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.listMine.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getAll.invalidate();
      // @ts-ignore - tRPC type issues
      utils.cashOut.getMy.invalidate();
      toast.success("Cash out approved successfully");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to approve cash out");
    },
  });

  // Export function (using vanilla client for imperative calls)
  const exportCashOuts = async (input: ExportCashOutsInput) => {
    try {
      // @ts-ignore - tRPC type issues
      const data = await vanillaClient.cashOut.export.query(input);

      // Create a blob from the CSV data
      const blob = new Blob([data.content], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = data.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Export completed successfully");
    } catch (error: any) {
      toast.error(error.message || "Failed to export cash outs");
    }
  };

  return {
    // Queries
    getCashOuts,
    getCashOut,

    // Mutations - use mutateAsync for promise support
    createCashOut: createCashOut.mutateAsync,
    updateCashOut: updateCashOut.mutateAsync,
    deleteCashOut: deleteCashOut.mutateAsync,
    approveCashOut: approveCashOut.mutateAsync,
    exportCashOuts,

    // Loading states
    isCreating: createCashOut.isLoading,
    isUpdating: updateCashOut.isLoading,
    isDeleting: deleteCashOut.isLoading,
    isApproving: approveCashOut.isLoading,
    isExporting: false, // Export is a manual query, not tracked
  };
}
